import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { PlatnoscService } from '../../../@core/http/platnosc.service';
import { Platnosc } from '../../../shared/models/platnosc.model';
import { ZakresDat } from '../../../shared/models/zakres-dat.model';

@Component({
  selector: 'ngx-mobile-faktury-dialog',
  templateUrl: './mobile-faktury-dialog.component.html',
  styleUrls: ['./mobile-faktury-dialog.component.scss']
})
export class MobileFakturyDialogComponent implements OnInit {
  
  dane: Platnosc[] = [];
  loading = false;

  constructor(
    private dialogRef: NbDialogRef<MobileFakturyDialogComponent>,
    private platnoscService: PlatnoscService
  ) {}

  ngOnInit(): void {
    this.loadUnpaidInvoices();
  }

  private loadUnpaidInvoices(): void {
    this.loading = true;
    
    // Create a wide date range to get all unpaid invoices
    const currentDate = new Date();
    const startDate = new Date(currentDate.getFullYear() - 2, 0, 1); // 2 years ago
    const endDate = new Date(currentDate.getFullYear() + 1, 11, 31); // 1 year ahead
    
    const zakresDat = new ZakresDat(startDate, endDate);

    this.platnoscService.getPlatnosci(zakresDat).subscribe(
      (platnosci: Platnosc[]) => {
        // Filter only unpaid invoices (where kwotaPozostala > 0)
        this.dane = platnosci.filter(platnosc => 
          platnosc.kwotaPozostala && platnosc.kwotaPozostala > 0
        );
        this.loading = false;
      },
      (error) => {
        console.error('Error loading payments:', error);
        this.loading = false;
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }
}
